import {
  Hero, TodaysDoorway, WhyDifferent, ChooseByProblem, FindMyDoorwayBlock,
  ModernLife, ExploreFamilies, FeaturedTechniquePreview, PopularDoorways,
  ChooseDepth, PresentGeneration, PracticeGently, FinalCTA,
} from "../components/HomeSections.jsx";
import Seo from "../components/Seo.jsx";

export default function Home() {
  return (
    <>
      <Seo
        title="Simple Meditation World — 112 Ancient Doorways for the Modern Mind"
        description="The Vigyan Bhairava Tantra's 112 meditation techniques, translated into simple modern practices for breath, sound, body, emotion, space, sleep, love, and ordinary life."
        path="/"
      />
      <Hero />
      <TodaysDoorway />
      <WhyDifferent />
      <ChooseByProblem />
      <FindMyDoorwayBlock />
      <ModernLife />
      <ExploreFamilies />
      <FeaturedTechniquePreview />
      <PopularDoorways />
      <ChooseDepth />
      <PresentGeneration />
      <PracticeGently />
      <FinalCTA />
    </>
  );
}
